import React, { useCallback, useMemo } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import ServerSideDataSource from './ServerSideDataSource';
import { TableWrapper } from './TableView.styles';

const TableView = ({ gridRef, columnDefs }) => {
	const gridStyle = useMemo(
		() => ({
			height: '54vh',
			width: '100%',
		}),
		[]
	);

	const defaultColDefs = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			editable: false,
		};
	}, []);

	const gridOptions = {
		modules: AllModules,
		columnDefs: columnDefs,
		cacheBlockSize: 200,
		maxBlocksInCache: 10,
		enableColResize: true,
		enableSorting: true,
		enableFilter: true,
		rowModelType: 'serverSide',
		floatingFilter: true,
		maxConcurrentDatasourceRequests: 1,
		multiSortKey: 'ctrl',
		enableRangeSelection: true,
		suppressCutToClipboard: true,
	};

	const onGridReady = useCallback(
		params => {
			gridRef.current.api.startEditingCell(params);
			const gridOptionsnew = {
				columnDefs,
				suppressRowClickSelection: true,
				...gridOptions,
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				params.columnApi,
				params.api
			);
			params.api.setServerSideDatasource(datasource);
		},
		// eslint-disable-next-line
		[columnDefs, gridOptions]
	);

	return (
		<TableWrapper>
			<div style={gridStyle} className="ag-theme-balham">
				<AgGridReact
					ref={gridRef}
					modules={AllModules}
					columnDefs={columnDefs}
					cacheBlockSize={200}
					defaultColDef={defaultColDefs}
					maxBlocksInCache={10}
					enableColResize={true}
					enableSorting={true}
					enableFilter={true}
					enableGroupEdit={true}
					rowModelType="serverSide"
					maxConcurrentDatasourceRequests={1}
					multiSortKey="ctrl"
					onGridReady={onGridReady}
					enableRangeSelection={true}
					suppressCutToClipboard={true}
					suppressCellFocus={true}
				/>
			</div>
		</TableWrapper>
	);
};

export default TableView;
